import React from 'react';

import {
  CaseBenefitsTabContent,
  CASE_BENEFIT_EM_TAG_CLOSE,
  CASE_BENEFIT_EM_TAG_OPEN,
  CASE_BENEFIT_SPECIAL_SPACE_CHARACTER,
} from '../case-benefits-tab-content';

const EM_TAG_OPEN = CASE_BENEFIT_EM_TAG_OPEN;
const EM_TAG_CLOSE = CASE_BENEFIT_EM_TAG_CLOSE;
const SPECIAL_SPACE_CHARACTER = CASE_BENEFIT_SPECIAL_SPACE_CHARACTER;

export const Case2BenefitsTabContent = React.memo(() => {
  const Case2Benefits = React.useMemo<string[]>(() => {
    const case1Benefits: string[] = [
      `${EM_TAG_OPEN}63%${SPECIAL_SPACE_CHARACTER}reduction${EM_TAG_CLOSE} in critical incidents`,
      `${EM_TAG_OPEN}0%${SPECIAL_SPACE_CHARACTER}sleeping${SPECIAL_SPACE_CHARACTER}cells${EM_TAG_CLOSE} - removal of all sleeping cells through AI prediction`,
      `Reduction in resolution time of ${EM_TAG_OPEN}28%${SPECIAL_SPACE_CHARACTER}for${SPECIAL_SPACE_CHARACTER}critical${EM_TAG_CLOSE} and ${EM_TAG_OPEN}66%${SPECIAL_SPACE_CHARACTER}for${SPECIAL_SPACE_CHARACTER}major${SPECIAL_SPACE_CHARACTER}incidents${EM_TAG_CLOSE}`,
      `Improvement in trouble ticket efficiency with ${EM_TAG_OPEN}96%${SPECIAL_SPACE_CHARACTER}automation${SPECIAL_SPACE_CHARACTER}in${SPECIAL_SPACE_CHARACTER}creation${EM_TAG_CLOSE} and ${EM_TAG_OPEN}60%${SPECIAL_SPACE_CHARACTER}in${SPECIAL_SPACE_CHARACTER}resolution.${EM_TAG_CLOSE}`,
    ];

    return case1Benefits;
  }, []);

  return <CaseBenefitsTabContent items={Case2Benefits} />;
});
